// @ts-nocheck
import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function StatusDistribution() {
  const { data: distribution, isLoading } = useQuery({
    queryKey: ["/api/dashboard/status-distribution"],
    refetchInterval: 60000, // Refresh every minute
  });

  const getStatusColor = (status: string) => {
    const colors = {
      open: "bg-green-500",
      in_progress: "bg-yellow-500",
      closed: "bg-blue-500",
      settled: "bg-purple-500",
    };
    return colors[status as keyof typeof colors] || "bg-muted/500";
  };

  const getStatusLabel = (status: string) => {
    const labels = {
      open: "Open",
      in_progress: "In Progress",
      closed: "Closed",
      settled: "Settled",
    };
    return labels[status as keyof typeof labels] || status;
  };

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-lg font-semibold text-foreground">
            Status Distribution
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="flex items-center justify-between animate-pulse">
                <div className="flex items-center space-x-2">
                  <div className="h-3 w-3 rounded-full bg-muted"></div>
                  <div className="h-4 bg-muted rounded w-20"></div>
                </div>
                <div className="h-4 bg-muted rounded w-16"></div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    );
  }

  // Calculate total for percentages
  const total = distribution?.reduce((sum: number, item: any) => sum + item.count, 0) || 0;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold text-foreground">
          Status Distribution
        </CardTitle>
      </CardHeader>
      <CardContent>
        {!distribution || distribution.length === 0 ? (
          <div className="text-center py-6 text-muted-foreground">
            No status data available.
          </div>
        ) : (
          <div className="space-y-3">
            {distribution.map((item: any) => {
              const percentage = total > 0 ? Math.round((item.count / total) * 100) : 0;
              
              return (
                <div 
                  key={item.status} 
                  className="flex items-center justify-between"
                  data-testid={`status-distribution-${item.status}`}
                >
                  <div className="flex items-center space-x-2">
                    <div className={`h-3 w-3 rounded-full ${getStatusColor(item.status)}`}></div>
                    <span className="text-sm text-foreground">
                      {getStatusLabel(item.status)}
                    </span>
                  </div>
                  <span 
                    className="text-sm font-medium text-foreground"
                    data-testid={`status-count-${item.status}`}
                  >
                    {item.count} ({percentage}%)
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
